import { Phone, ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      id="hero"
      className="relative min-h-[100vh] flex items-end overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1474742817425-9f91918183b7?auto=format&fit=crop&w=2000&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1810]/80 via-[#0B1810]/40 to-[#0B1810]/95" />
      <div className="grain absolute inset-0" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-20 pt-32 text-white">
        <div className="max-w-5xl reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-12 h-[2px] bg-[#FF5A00]" />
            <span className="overline text-white/90">
              Rockledge · Melbourne · Cocoa · Merritt Island · Since 2014
            </span>
          </div>

          <h1 className="h-massive text-white">
            Cutting Through
            <br />
            <span className="text-[#FF5A00]">The Storm.</span>
          </h1>

          <p className="mt-8 max-w-2xl text-lg md:text-xl text-white/80 font-body leading-relaxed">
            Brevard County's tree removal, trimming, stump grinding, landscaping
            and pool build specialists — proudly serving Rockledge, Melbourne,
            Cocoa, Cocoa Beach, Merritt Island, Cape Canaveral, Titusville and
            Viera, Florida. Ten years of rugged, reliable work. One call handles
            it all.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="hero-quote-button"
              href="#contact"
              className="btn-primary"
            >
              Get a Free Quote
            </a>
            <a
              data-testid="hero-phone-button"
              href="tel:+13216826085"
              className="btn-ghost-inverse"
            >
              <Phone size={18} /> (321) 682-6085
            </a>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl border-t border-white/20 pt-8">
            <div>
              <div className="font-heading text-4xl md:text-5xl text-[#FF5A00]">
                10+
              </div>
              <div className="font-accent text-xs tracking-widest uppercase text-white/60 mt-2">
                Years Pro
              </div>
            </div>
            <div>
              <div className="font-heading text-4xl md:text-5xl text-[#FF5A00]">
                500+
              </div>
              <div className="font-accent text-xs tracking-widest uppercase text-white/60 mt-2">
                Jobs Done
              </div>
            </div>
            <div>
              <div className="font-heading text-4xl md:text-5xl text-[#FF5A00]">
                24/7
              </div>
              <div className="font-accent text-xs tracking-widest uppercase text-white/60 mt-2">
                Storm Response
              </div>
            </div>
          </div>
        </div>

        <a
          href="#services"
          className="hidden md:flex absolute right-8 bottom-8 items-center gap-2 text-white/70 hover:text-[#FF5A00] transition-colors font-accent text-xs tracking-[0.25em] uppercase"
        >
          Scroll <ArrowDown size={14} />
        </a>
      </div>
    </section>
  );
}
